var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgSiteManagementHeaderLogo = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.684 35.26c-.003.582-.273.993-.707 1.187l-.69.316c-2.362-.771-1.485-9.938-1.63-12.543l.727-13.674c-.61-.817-2.957-1.528-2.409-3.195L14.051 4.87c-.309-.16-8.388-3.743-6.938-4.414.242-.113.482-.226.723-.332.535-.242 1.219-.092 1.719.129l13.778 6.05c1.353.598 2.413 2.04 2.41 3.194l-.06 25.763Z",
    fill: "#2E2E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.409 1.64c.001-.57.26-.977.678-1.174C7.529.258 8.148.28 8.833.583L22.61 6.632c1.332.59 2.413 2.021 2.408 3.194l-.057 25.763c-.005 1.174-1.092 1.647-2.424 1.058L8.76 30.597c-1.335-.59-2.413-2.021-2.41-3.194l.059-25.762Z",
    fill: "#2E2E2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.148 2.749c.003-1.08 1.002-1.517 2.232-.973l12.68 5.568c1.228.542 2.22 1.86 2.217 2.94l-.052 24.199c-.003 1.08-1.004 1.516-2.232.974L9.311 29.888c-1.228-.544-2.22-1.86-2.217-2.94l.054-24.2Z",
    fill: "url(#site-management-header-logo_svg__a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.495 16.085c.001-.185.173-.26.382-.166 2.237.981 9.632 4.26 11.869 5.243.211.093.381.32.381.504l.011 6.78c0 .184-.173.26-.383.166-2.236-.983-9.631-4.26-11.868-5.242-.211-.093-.381-.32-.381-.506l-.011-6.779Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.87 16.39c0-.048.045-.07.1-.044.587.258 1.173.526 1.761.784.056.024.1.084.1.132l.003 1.78c0 .05-.046.069-.101.044-.588-.257-1.174-.525-1.762-.783-.056-.024-.1-.084-.1-.132l-.002-1.78ZM12.34 17.453c0-.049.047-.068.102-.044.588.258 1.174.526 1.762.784.056.024.1.083.1.132l.003 1.78c0 .05-.044.069-.1.044-.588-.257-1.174-.525-1.76-.783-.056-.024-.1-.084-.1-.132l-.006-1.78ZM14.815 18.563c0-.05.046-.069.1-.044.588.258 1.174.525 1.762.783.056.024.1.084.1.133l.003 1.781c0 .049-.046.068-.1.044-.588-.258-1.174-.525-1.762-.783-.055-.024-.1-.084-.1-.133l-.003-1.781ZM17.286 19.647c0-.049.046-.068.1-.044.588.258 1.174.526 1.762.784.056.024.1.083.1.132l.003 1.78c0 .05-.046.069-.1.044-.587-.258-1.175-.525-1.761-.783-.056-.024-.1-.084-.1-.133l-.004-1.78ZM19.76 20.714c0-.049.046-.068.1-.044.587.258 1.174.525 1.761.783.056.025.1.084.1.133l.004 1.78c0 .05-.047.069-.1.044-.588-.258-1.174-.525-1.762-.783-.056-.024-.1-.084-.1-.133l-.004-1.78ZM9.87 18.806c0-.049.045-.068.1-.044.587.258 1.173.525 1.761.783.056.024.1.084.1.133l.003 1.78c0 .049-.046.07-.101.044-.588-.258-1.174-.525-1.762-.783-.056-.024-.1-.084-.1-.133l-.002-1.78ZM12.34 19.87c0-.049.047-.068.102-.044.588.258 1.174.526 1.762.784.056.024.1.084.1.132l.003 1.78c0 .05-.044.069-.1.045-.588-.258-1.174-.526-1.76-.784-.056-.024-.1-.084-.1-.132l-.006-1.78ZM14.815 20.978c0-.049.046-.068.1-.044.588.258 1.174.526 1.762.784.056.024.1.083.1.132l.003 1.78c0 .05-.046.069-.1.044-.588-.258-1.174-.525-1.762-.783-.055-.024-.1-.084-.1-.132l-.003-1.78ZM17.286 22.064c0-.049.046-.068.1-.044.588.258 1.174.526 1.762.784.056.024.1.083.1.132l.003 1.78c0 .05-.046.069-.1.044-.587-.258-1.175-.525-1.761-.783-.056-.024-.1-.084-.1-.133l-.004-1.78ZM19.76 23.13c0-.048.046-.068.1-.043.587.258 1.174.525 1.761.783.056.024.1.084.1.132l.004 1.78c0 .05-.047.069-.1.045-.588-.258-1.174-.526-1.762-.784-.056-.024-.1-.083-.1-.132l-.004-1.78ZM9.87 21.222c0-.048.045-.068.1-.044.587.258 1.173.526 1.761.784.056.024.1.084.1.132l.003 1.78c0 .05-.046.069-.101.045-.588-.258-1.174-.526-1.762-.784-.056-.024-.1-.084-.1-.132l-.002-1.78ZM12.34 22.285c0-.048.047-.068.102-.044.588.258 1.174.526 1.762.784.056.024.1.084.1.132l.003 1.78c0 .05-.044.069-.1.044-.588-.257-1.174-.525-1.76-.783-.056-.024-.1-.084-.1-.132l-.006-1.78ZM14.815 23.394c0-.048.046-.068.1-.044.588.258 1.174.526 1.762.784.056.024.1.084.1.132l.003 1.78c0 .05-.046.069-.1.044-.588-.258-1.174-.525-1.762-.783-.055-.024-.1-.084-.1-.132l-.003-1.78ZM17.286 24.48c0-.048.046-.068.1-.043.588.258 1.174.525 1.762.783.056.024.1.084.1.133l.003 1.78c0 .049-.046.068-.1.044-.587-.258-1.175-.526-1.761-.783-.056-.025-.1-.084-.1-.133l-.004-1.78ZM19.76 25.546c0-.049.046-.068.1-.044.587.258 1.174.526 1.761.783.056.025.1.084.1.133l.004 1.78c0 .05-.047.069-.1.044-.588-.258-1.174-.525-1.762-.783-.056-.024-.1-.084-.1-.133l-.004-1.78Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.479 5.211c0-.256.238-.36.529-.23 3.086 1.354 10.52 4.71 13.606 6.066.29.128.526.441.526.696l.015 9.353c-.001.257-.238.36-.529.231-3.086-1.355-10.52-4.71-13.606-6.066-.29-.13-.526-.442-.526-.697L8.48 5.21Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.854 5.865c0-.12.113-.168.25-.106l3.105 1.344c.138.062.248.211.248.332v.24c0 .12-.113.167-.25.105L9.102 6.436c-.138-.063-.248-.212-.248-.332v-.24ZM8.854 6.913c0-.107.099-.149.22-.094 1.76.763 4.646 2.006 6.408 2.767.12.055.219.186.219.293v.21c0 .107-.1.149-.221.094-1.76-.763-4.647-2.005-6.407-2.767-.12-.055-.219-.186-.217-.292v-.211h-.002ZM8.821 8.796c0-.135.126-.189.28-.118 4.446 1.924 8.904 3.833 13.352 5.757.154.07.278.237.278.372v.268c0 .135-.126.188-.28.118-4.446-1.923-8.904-3.834-13.35-5.758-.154-.07-.278-.237-.278-.372v-.267H8.82ZM8.821 10.214c0-.135.126-.189.28-.12 4.446 1.925 8.904 3.834 13.352 5.758.154.07.278.237.278.372v.268c0 .136-.126.188-.28.118-4.446-1.924-8.904-3.833-13.35-5.758-.154-.069-.278-.237-.278-.372v-.266H8.82ZM8.821 11.632c0-.136.126-.189.28-.118 4.446 1.924 8.904 3.833 13.352 5.757.154.07.278.237.278.372v.268c0 .135-.126.188-.28.118-4.446-1.924-8.904-3.834-13.35-5.758-.154-.07-.278-.237-.278-.372v-.267H8.82ZM8.821 13.05c0-.136.126-.19.28-.12l4.854 2.141c.154.07.278.237.278.372v.268c0 .135-.125.188-.28.118L9.1 13.689c-.154-.071-.278-.238-.278-.373v-.266Z",
    fill: "#00AF9B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.938 25.403c-.709-.313-1.287-.061-1.288.562-.002.621.572 1.383 1.28 1.696.705.313 1.284.06 1.287-.562.001-.622-.572-1.384-1.279-1.696Z",
    fill: "#FFDB69"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.423 26.231c.146.064.265.013.265-.114 0-.128-.118-.285-.264-.35-.146-.065-.263-.013-.265.115 0 .128.117.284.264.349ZM13.441 27.133c-.028-.012-.055-.014-.077-.004a.406.406 0 0 1-.197.035.701.701 0 0 1-.235-.062 1.025 1.025 0 0 1-.237-.147 1.203 1.203 0 0 1-.197-.21.198.198 0 0 0-.076-.064.105.105 0 0 0-.074-.007c-.044.015-.046.074-.006.131a1.505 1.505 0 0 0 .59.486c.112.05.22.076.317.083a.529.529 0 0 0 .269-.047c.041-.02.038-.08-.003-.133a.18.18 0 0 0-.074-.06ZM13.445 26.218c-.146-.065-.264-.013-.265.115 0 .128.117.285.263.35.145.064.266.011.266-.116 0-.128-.118-.285-.264-.35Z",
    fill: "#3E4992"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.785 26.661c-.705-.312-1.283-.06-1.287.563-.001.622.572 1.383 1.28 1.696.708.314 1.286.06 1.288-.56.003-.623-.572-1.385-1.28-1.699Z",
    fill: "#FFDB69"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.274 27.49c.146.065.265.013.265-.115s-.118-.284-.264-.349c-.146-.064-.264-.012-.265.116 0 .127.119.285.264.349ZM16.105 28.307a1.453 1.453 0 0 0-.318-.198.955.955 0 0 0-.326-.084.52.52 0 0 0-.27.054c-.04.02-.038.081.007.136.02.024.046.045.071.056.03.013.059.016.08.005a.38.38 0 0 1 .198-.04.715.715 0 0 1 .24.062 1.135 1.135 0 0 1 .43.354c.021.029.05.05.078.064.027.01.053.015.073.006.043-.016.047-.074.007-.129a1.624 1.624 0 0 0-.27-.286ZM16.294 27.476c-.146-.064-.264-.012-.265.116-.002.128.117.285.262.349.146.064.265.013.267-.114.001-.128-.118-.286-.264-.35Z",
    fill: "#3E4992"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.704 27.91c-.705-.312-1.285-.06-1.287.563-.001.62.572 1.382 1.28 1.695.706.312 1.286.06 1.288-.56.001-.623-.574-1.386-1.28-1.699Z",
    fill: "#FFDB69"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.455 28.623c0-.127-.118-.284-.262-.349-.147-.064-.266-.012-.266.116 0 .127.118.284.264.349.145.064.264.012.264-.116ZM18.698 29.398c-.167-.073-.304-.09-.304-.038 0 .055.137.16.304.233.168.074.305.09.305.036 0-.052-.137-.155-.305-.23ZM19.212 28.724c-.147-.064-.264-.012-.266.116 0 .127.118.284.264.349.146.064.265.012.265-.116 0-.127-.119-.283-.263-.35Z",
    fill: "#3E4992"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.596 16.042c1.418.703 3.26 1.66 4.217.096.356-.58.997-1.426 1.211-2.044.144-.413.364-1.841 1.17-1.107.293.267.181.755.22 1.092.097-.03.302-.097.383-.04.216.148-.458.594-.664.734-1.57 3.001-1.813 3.93-3.909 4.038-.133.007-1.631-.248-1.946-.356a2.558 2.558 0 0 1-.606-.325c-.325-.225-.35-.63-.706-.842",
    fill: "url(#site-management-header-logo_svg__b)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1.006 37.823s-.143.43-.185.591c-.026.098.028.364.073.553.03.127.138.228.278.258a1 1 0 0 0 .73-.12l1.955-1.193c.104-.063.138-.188.079-.286l-.053-.09a.397.397 0 0 0-.433-.174c-.44.102-1.263.27-1.555.202-.406-.095-.89.26-.89.26Z",
    fill: "#00AF9B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M.946 36.543s.006 1.265.06 1.44c.053.178.688.172.859-.208.145-.323.224-1.373.224-1.373l-1.143.141Z",
    fill: "url(#site-management-header-logo_svg__c)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.489 38.53s-.197.413-.26.567c-.038.095-.018.365.003.558.014.13.108.24.243.286.243.08.512.065.741-.044l2.095-.98c.11-.053.16-.172.115-.277l-.04-.095a.393.393 0 0 0-.41-.218c-.451.054-1.289.137-1.569.038-.393-.136-.918.165-.918.165Z",
    fill: "#00AF9B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.423 37.35s-.108 1.261-.072 1.441c.037.18.672.222.876-.145.173-.31.348-1.352.348-1.352l-1.152.057Z",
    fill: "url(#site-management-header-logo_svg__d)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M.24 23.894s.664 4.96.435 6.27c-.436 2.485.101 6.38.101 6.38.493.276 1.007.275 1.412 0 0 0 .636-8.28 1.776-10.038V23.72l-1.517-1.497-1.633-.26c-.498.197-.668 1.446-.575 1.93Z",
    fill: "#2E2E2E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.741 23.318s-.261 3.383-.804 6.786c-.512 3.202-1.304 6.403-1.417 7.343a.465.465 0 0 1-.231.344c-.173.105-.451.204-.837.133a.323.323 0 0 1-.268-.275c-.118-1.044-.18-5.807-.177-6.666.004-.971-.918-6.695-.918-6.695l.3-2.326 4.352 1.356Z",
    fill: "#2E2E2E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M4.414 13.854s2.898 2.21 2.327 3.913c-.839 2.503.644 6.74.658 7.773.001.088-.082.157-.18.146-.191-.02-.467-.16-.478-.784 0 0 .189 1.076-.64 1.357-.828.28-4.373.47-5.632-.372 0 0-1.179-1.331.2-4.61 1.56-3.706-1.539-5.239.384-7.352.653-.716 1.604-.864 3.361-.07Z",
    fill: "#00AF9B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m4.798 12.284-.18 1.57c-.013.123-.117.22-.25.24a1.96 1.96 0 0 1-1.352-.27.47.47 0 0 1-.214-.527l.32-1.157 1.676.144Z",
    fill: "url(#site-management-header-logo_svg__e)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.683 9.727s.336 1.978.115 2.501c-.219.523-1.595.762-1.947.607-.352-.155-1.392-1.232-1.447-1.709-.224-1.923 2.002-2.451 3.279-1.4Z",
    fill: "url(#site-management-header-logo_svg__f)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3.884 11.105c.55.06 3.4-1.276 2.003-1.971-2.27-1.13-5.085.443-5.344 2.572-.148.641-.095 2.503.528 2.982 1.124.685 3.729.147 4.07-.598v.007c-.5-1.168-.903-2.152-.718-3.41",
    fill: "#FF0082"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8.898 21.843h-.003a2.055 2.055 0 0 1-.178-.047c-.46-.145-2.175-.48-2.51-.993-.721-1.102-.148-3.845-.949-4.773-.802-.927-1.873-.095-2.075.483-.201.577.665 4.714 1.484 5.618.755.835 3.415.756 4.281.784.112.004.223.021.331.047.2.047.393.068.624.16.384.152.513.686.655.864a.187.187 0 0 0 .059.049c.117.063.27-.016.298-.139.246-1.06-.604-2.015-1.654-2.013-.123.001-.245-.014-.363-.04Z",
    fill: "url(#site-management-header-logo_svg__g)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "site-management-header-logo_svg__a",
    x1: 22.659,
    y1: 11.518,
    x2: 13.286,
    y2: 27.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "site-management-header-logo_svg__b",
    x1: 4.179,
    y1: 15.364,
    x2: 11.615,
    y2: 16.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#612909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.134,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "#AB4904"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "site-management-header-logo_svg__c",
    x1: 0.946,
    y1: 37.249,
    x2: 2.089,
    y2: 37.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#AB4904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#612909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "site-management-header-logo_svg__d",
    x1: 3.359,
    y1: 38.055,
    x2: 4.496,
    y2: 38.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#AB4904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#612909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "site-management-header-logo_svg__e",
    x1: 2.009,
    y1: 10.129,
    x2: 6.798,
    y2: 19.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#AB4904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#612909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "site-management-header-logo_svg__f",
    x1: 2.6,
    y1: 15.997,
    x2: 5.195,
    y2: 6.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#AB4904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#612909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "site-management-header-logo_svg__g",
    x1: 9.282,
    y1: 20.939,
    x2: 2.76,
    y2: 17.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#AB4904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#612909"
  })))));
};
export { SvgSiteManagementHeaderLogo as ReactComponent };
export default __webpack_public_path__ + "0fef967966e50149914d65df2fa12a18.svg";